import { SELECTORS } from './config';
import { ContactWizard } from './contactWizard';

function initContactWizard() {
    const WIZARD = document.querySelector(SELECTORS.WIZARD);

    if (WIZARD) {
        // eslint-disable-next-line no-new
        new ContactWizard(WIZARD);
    }
}

export { initContactWizard };
